/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Intensity_MildInputs */

const en_us2_profile_editors_pain_intensity_mild = /** @type {(inputs: Profile_Editors_Pain_Intensity_MildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mild`)
};

const pt_br2_profile_editors_pain_intensity_mild = /** @type {(inputs: Profile_Editors_Pain_Intensity_MildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leve`)
};

const es_419_profile_editors_pain_intensity_mild = /** @type {(inputs: Profile_Editors_Pain_Intensity_MildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leve`)
};

const pt_pt2_profile_editors_pain_intensity_mild = /** @type {(inputs: Profile_Editors_Pain_Intensity_MildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leve`)
};

const fr_fr2_profile_editors_pain_intensity_mild = /** @type {(inputs: Profile_Editors_Pain_Intensity_MildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`légère`)
};

const de_de2_profile_editors_pain_intensity_mild = /** @type {(inputs: Profile_Editors_Pain_Intensity_MildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leicht`)
};

const it_it2_profile_editors_pain_intensity_mild = /** @type {(inputs: Profile_Editors_Pain_Intensity_MildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lieve`)
};

/**
* | output |
* | --- |
* | "mild" |
*
* @param {Profile_Editors_Pain_Intensity_MildInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_intensity_mild = /** @type {((inputs?: Profile_Editors_Pain_Intensity_MildInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Intensity_MildInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_intensity_mild(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_intensity_mild(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_intensity_mild(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_intensity_mild(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_intensity_mild(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_intensity_mild(inputs)
	return en_us2_profile_editors_pain_intensity_mild(inputs)
});
export { profile_editors_pain_intensity_mild as "profile-editors.pain_intensity_mild" }